import classNames from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import type { CSSProperties, FC } from 'react'

import styles from './Banner.module.scss'

export type BannerProps = {
	imgSrcDesk: string
	imgSrcMob: string
	imgSrcTablet?: string
	imgAlt?: string
	link?: string
	imgDeskWidth: number
	imgMobWidth: number
	imgDeskHeight: number
	imgMobHeight: number
	imgTabletWidth?: number
	imgTabletHeight?: number
	title?: string
	maxWidth?: string
	disabled?: boolean
	onClick?: () => void
	className?: string
	priority?: boolean
	style?: CSSProperties
}

export const Banner: FC<BannerProps> = ({
	imgSrcDesk,
	imgSrcTablet,
	imgSrcMob,
	imgAlt = 'banner',
	imgDeskWidth,
	imgMobWidth,
	imgDeskHeight,
	imgMobHeight,
	imgTabletWidth,
	imgTabletHeight,
	title = '',
	maxWidth = '1920px',
	disabled,
	link,
	onClick,
	className,
	priority,
	style
}) => {
	const bannerContent = (
		<article
			className={classNames(styles.banner, className, { [styles.disabled]: disabled || !link })}
			style={{ maxWidth, ...style }}
			title={`Перейти на страницу «${title}»`}
			onClick={disabled ? undefined : onClick}>
			<picture style={{ width: `100%` }}>
				<source media="(min-width: 1024px)" srcSet={imgSrcDesk} width={imgDeskWidth} height={imgDeskHeight} />
				<source
					media="(min-width: 768px)"
					srcSet={imgSrcTablet || imgSrcMob}
					width={imgTabletWidth || imgMobWidth}
					height={imgTabletHeight || imgMobHeight}
				/>
				<Image
					src={imgSrcMob}
					alt={imgAlt}
					width={imgMobWidth}
					height={imgMobHeight}
					priority={priority}
					className={styles.image}
				/>
			</picture>
		</article>
	)

	return link && !disabled ? (
		<Link prefetch={false} href={link} className={styles.link} target="_blank">
			{bannerContent}
		</Link>
	) : (
		bannerContent
	)
}
